export const RowFields = {
    BillNumber: { id: "billNumber", type: "text", placeholder: "Bill Number" },
    StartDatesOfService: { id: "startDatesOfService", type: "date", placeholder: "Start Date" },
    EndDatesOfService: { id: "endDatesOfService", type: "date", placeholder: "End Date" },
    DateBillSent: { id: "dateBillSent", type: "date", placeholder: "Date Bill Sent" },
    AmountPaid: { id: "amountPaid", type: "text", placeholder: "Amount Paid" },
    DatePaid: { id: "datePaid", type: "date", placeholder: "Date of Payment" },
}

export const OfficeAddresses = [
    {
        name: "Beverly Park Medical Center",
        line1: "11012 S. Western",
        line2: "Chicago, IL 60643",
    },
    {
        name: "Midway Medical Center",
        line1: "4354 W 63rd",
        line2: "Chicago IL 60629",
    },
    {
        name: "Oak Park Medical Center",
        line1: "6326 Roosevelt Rd",
        line2: "Oak Park, IL 60304",
    },
    {
        name: "Jackson Park Medical Associates",
        line1: "7531 S. Stony Island, Ste. 176",
        line2: "Chicago, IL 60649",
    },
    {
        name: "Northside Medical Center",
        line1: "2656 W. Montrose Ave, #100",
        line2: "Chicago, IL 60618",
    },
    {
        name: "South Holland Medical Center",
        line1: "16131 Lasalle St.",
        line2: "South Holland, IL 60473",
    },
    {
        name: "Hyde Park Medical Center",
        line1: "5554 S. Hyde Park Blvd., Ste. 109",
        line2: "Chicago, IL 60637"
    }
]

export const MetaFields = {
    PatientName: { id: "patientName", type: "text", placeholder: "Patient Name" },
    AttorneyName: { id: "attorneyName", type: "text", placeholder: "Attorney Name" },
    OfficeAddress: { id: "officeAddress", type: "text", placeholder: "Office Location", options: OfficeAddresses },
    ClaimNumber: { id: "claimNumber", type: "text", placeholder: "Claim Number" },
    InsuranceCompany: { id: "insuranceCompany", type: "text", placeholder: "Insurance Company"}
}

export const MetaFieldIdArray = Object.values(MetaFields).map( fieldObj => fieldObj.id);

export const ComputedFields = {
    DateInterestStartedAccruing: { id: "dateInterestStartedAccruing" }, // 30 days after dateBillSent 
    InterestSinceLatePayment: { id: "interestSinceLatePayment"},
    TotalInterestAccrued: { id: "totalInterestAccrued"},
    DaysBetweenSelectedDates: { id: "daysBetweenSelectedDates"}
}

// These are fields that should be copied from the parent "normal" row
export const PARTIAL_FIELDS = [
    RowFields.BillNumber.id,
    RowFields.StartDatesOfService.id,
    RowFields.EndDatesOfService.id,
    RowFields.DateBillSent.id
]

export const TEST_PDF_DATA = {
    rowData: [
        {
            description: "Interest only for dates of service 8/12/2013 overdue partial payment of $69 received 03/26/2016",
            value: 6969.69
        },
        {
            description: "Interest only for dates of service 1/19/2015, overdue payment of $X.XX received 03/26/2019",
            value: 4399.69
        },
        {
            description: "poopopopop",
            value: 359
        },
        {
            description: "dfsapd fopsdajf djasklfjlasdfa",
            value: 439
        }
    ],
    metaData: {
        fromAddress: {
            name: "Fake FromName",
            line1: "123 Any St.",
            line2: "South FakeLand, AB 12345"
        },
        toAddress: {
            name: "FAKEFIRST FAKELAST",
            attorneyName: "FAKE ATTORNEY"
        },
        claimArea: {
            re: "FAKEREEEEEE",
            claimNumber: 123468
        }
    }
}